import React, { Component } from 'react';
import { Result, Button } from 'antd';


class NotFound extends Component {
    render() {
        return (

            <div>
                <Result
                    status="404"
                    title="404"
                    subTitle="Pagina non esistente."
                    extra={<Button type="primary" onClick={() => { this.props.history.push("/") }}>Torna indietro</Button>}
                />,
            </div>
        );
    }
}

export default NotFound;